<template>
  <section class="py-8 md:py-14">
    <div class="mx-auto max-w-6xl px-4 text-center lg:px-0">
      <h2 class="-mt-1 mb-[34px] text-xl font-bold md:text-2xl lg:text-3xl">
        No more tedious document management!
      </h2>

      <GetStartedBtn />

      <h3
        id="how-it-works"
        class="mt-10 mb-7 text-3xl font-bold md:mt-20 md:text-4xl lg:mt-28 lg:text-5xl"
      >
        How it works
      </h3>
      <hr class="mb-10 text-[#E6E6EA]" />
      <div class="flex flex-col gap-8 text-left md:gap-10">
        <TransitionGroup name="stagger" appear>
          <FeatureItem
            v-for="(item, i) in items"
            :key="item.title"
            :number="i + 1"
            :style="{ transitionDelay: `${i * 70}ms` }"
            v-bind="item"
          />
        </TransitionGroup>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import GetStartedBtn from '../GetStartedBtn.vue';
import FeatureItem from './FeatureItem.vue';

const items = [
  {
    title: 'Upload your files',
    desc: 'Drag and drop, or choose files for your batch of documents. Choose to edit your batch with a <br/><b>Template</b> and or <b>Find and Replace.</b>',
    imgSrc: '/img/feat1.png',
  },
  {
    title: 'Choose a template',
    desc: 'Choose a template to apply to your batch of documents.',
    imgSrc: '/img/feat2.png',
  },
  {
    title: 'Find and Replace',
    desc: 'Find and Replace text across your batch of <br/>documents.',
    imgSrc: '/img/feat3.png',
  },
  {
    title: 'Batch completed',
    desc: 'View your completed batch of documents, before exporting and downloading.',
    imgSrc: '/img/feat4.png',
  },
];
</script>

<style scoped>
.stagger-enter-active {
  transition: all 0.35s ease;
}
.stagger-enter-from {
  opacity: 0;
  transform: translateY(14px);
}
</style>
